import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        warningTitle: {
            fontWeight: theme.typography.h4.fontWeight,
        },
        warningContent: {
            display: 'flex',
            flexDirection: 'column',
            gap: theme.spacing(0.2),
        },
        generatePdfCheckbox: {
            alignSelf: 'flex-end',
        },
    }
})

export default useStyles
